"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddSalesOrderFiles = void 0;
const class_validator_1 = require("class-validator");
const common_1 = require("../../common");
class AddSalesOrderFiles extends common_1.BaseAction {
}
__decorate([
    class_validator_1.IsMongoId()
], AddSalesOrderFiles.prototype, "orderHeaderId", void 0);
__decorate([
    class_validator_1.IsArray(),
    class_validator_1.IsString({ each: true }),
    class_validator_1.IsNotEmpty({ each: true })
], AddSalesOrderFiles.prototype, "fileIds", void 0);
exports.AddSalesOrderFiles = AddSalesOrderFiles;
//# sourceMappingURL=add-sales-order-files.action.js.map